import { Flex } from "@illimity/web/ui";
import { Spinner } from "@orion/ui";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useCookies } from "react-cookie";
import { startAuthorize } from "../actions/authorizeActions";

export default function LandingPage() {
  const dispatch = useDispatch();
  const [_cookies, setCookie] = useCookies(['auth_flow_token']);

  useEffect(() => {
    const expirationTime = new Date();
    expirationTime.setMinutes(expirationTime.getMinutes() + 2);
    
    setCookie('auth_flow_token', 'valid', {
      path: '/',
      expires: expirationTime,
      secure: true,
      sameSite: 'strict'
    });

    const params = new URLSearchParams(window.location.search);
    const nonce = params.get("nonce") || "";
    const state = params.get("state") || "";
    const codeVerifier = params.get("codeVerifier") || "";
    const redirect_uri = params.get("redirectUri") || "";
    dispatch(startAuthorize(codeVerifier, nonce, state,redirect_uri));
  }, []);

  return (
    <Flex height="100vh" justifyContent="center" alignItems="center">
      <Spinner size="20" />
    </Flex>
  );
}
